import { SwimlaneItem } from '../../forces/assetDetails/assetDetails.types';
import { usePinStore } from '../pin/usePinStore';

import { buildSwimlaneItemAriaLabel, SwimlaneItemAriaLabelOptions } from './swimlaneItemAriaLabel';

/**
 * Same as `buildSwimlaneItemAriaLabel`, but resolves the age limit from the user's parental control
 * settings. Items that render no `AgeLimitPill` can call the builder directly instead.
 */
export const useSwimlaneItemAriaLabel = (item: SwimlaneItem, options: SwimlaneItemAriaLabelOptions = {}): string => {
  /* subscribes to the whole store on purpose – parental settings are fetched async, and the label has
     to be rebuilt once they arrive (same as `AgeLimitPill`) */
  const { assetIsAgeRestricted } = usePinStore();

  return buildSwimlaneItemAriaLabel(item, { ...options, showAgeLimit: assetIsAgeRestricted(item.ageLimit) });
};
